<script>
  export let hint;
</script>

<div class="bg-custom-yellow w-80 tc f6 br-pill pv2 ph3">
  <p class="pa0 ma0">{hint}</p>
</div>

<style>
  div {
    opacity: 0;
    animation: blink 4s;
    animation-iteration-count: infinite;
  }

  @keyframes blink {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
</style>
